// extracted by mini-css-extract-plugin
export default {"container":"Last_container__XCTOy","arrow":"Last_arrow__+jWOC"};